import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
const uuid = require('uuid');

const Globals = require('../../../../app/globals');
const ChannelStore = require('../../stores/channel_store_reflux');
const AnalyticsActions = require('../../actions/AnalyticsActions');
const AnalyticsStore = require('../../stores/AnalyticsStore');
const PermissionsUtil = require('../../../../app/shared/PermissionsUtil');
const FeatureUtil = require('../../../../app/shared/FeatureUtil');
import Navigator from '../../Navigator';
import MainNav from '../DashboardNew/Menu/MainNav';
import SubNav from '../nav/SubNav';
import BackButton from '../nav/BackButton';
import BreadCrumbs from '../common/BreadCrumbs';
import ProjectListAnalyticsView from './ProjectListAnalyticsView';

const propTypes = {
    match: PropTypes.shape({
        params: PropTypes.object.isRequired,
    }).isRequired,
    history: PropTypes.object.isRequired
};

const defaultProps = {};

class ChannelProjectAnalyticsView extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            channelStoreState: ChannelStore.getState(),
            analyticsStoreState: AnalyticsStore.getState(),
            getOverviewActionId: null
        };

        this.backHandler = this.backHandler.bind(this);
        this.onProjectClick = this.onProjectClick.bind(this);
        this.checkToGetAnalytics = this.checkToGetAnalytics.bind(this);
        this.unsubscribes = [ChannelStore.listen(this.onChannelStoreChange.bind(this)),
                                AnalyticsStore.listen(this.onAnalyticsStoreChage.bind(this))];
    }

    UNSAFE_componentWillMount() {
        this.checkToGetAnalytics(this.state.channelStoreState, this.state.projectStoreState);
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(unsubscribeCallback => { unsubscribeCallback(); });
    }

    onChannelStoreChange(state) {
        if (state.initialized) {
            const currentChannel = state.channelsAndOrgs.find(ch => ch.id === parseInt(this.props.match.params.channelId, 10));
            if (!currentChannel) { // channel does not exist or user does not have permissions in channel
                Navigator.goToDashboardAuthorView.bind(this, this.props.history, Globals.view_tokens.dashboard.AUTHORING);
                return;
            }
        }

        this.setState({ channelStoreState: state }, () => {
            this.checkToGetAnalytics(state, this.state.projectStoreState);
        });
    }

    onAnalyticsStoreChage(state) {
        let additionalState = {};
        if (state.action.id === this.state.getOverviewActionId) {
            additionalState = { ...additionalState, getOverviewActionId: null };
        }

        this.setState({ analyticsStoreState: state, ...additionalState });
    }

    checkToGetAnalytics(channelStoreState) {
        if (channelStoreState.initialized) {
            const currentChannel = channelStoreState.channelsAndOrgs.find(ch => ch.id === parseInt(this.props.match.params.channelId, 10));
            // account does not have detailed analytics
            if (!FeatureUtil.hasDetailedAnalytics(currentChannel.channel_permissions)) {
                console.warn('Account does not have Detailed Analytics feature');
                this.backHandler();
                return;
            }

            // user does not have channel permissions to view analytics
            if (!PermissionsUtil.viewDetailedChannelAnalytics(currentChannel.user_permissions)) {
                this.backHandler();
                return;
            }

            if (!this.state.analyticsStoreState.channelProjectOverview[this.props.match.params.channelId]) {
                const actionId = uuid.v4();
                this.setState({ getOverviewActionId: actionId }, () => {
                    AnalyticsActions.getChannelProjectOverview(actionId, { id: this.props.match.params.channelId });
                });
            }
        }
    }

    backHandler() {
        Navigator.goToDashboardAuthorAuthoringChannelView(this.props.history, this.props.match.params.channelId, Globals.view_tokens.author_dash.channel_views.ANALYTICS);
    }

    onProjectClick(projectId) {
        // TODO
        this.props.history.push(`/analytics/${this.props.match.params.channelId}/projects/${projectId}`);
    }

    render() {
        const currentChannelId = parseInt(this.props.match.params.channelId, 10);
        if (
            !this.state.channelStoreState.initialized
            || !this.state.analyticsStoreState.channelProjectOverview[currentChannelId]
        ) {
            return null;
        }

        const currentChannel = this.state.channelStoreState.channelsAndOrgs.find(c => c.id === currentChannelId);
        const projects = this.state.analyticsStoreState.channelProjectOverview[currentChannelId];
        return (
            <div>
                <MainNav
                    onClickBrandLogo={() => Navigator.goToDashboardAuthorAuthoringChannelView(this.props.history, this.props.match.params.channelId)}
                />
                <div className="container-fluid main-container">
                    <SubNav containerClassName="subnav__container-fluid">
                        <BackButton backHandler={this.backHandler} />
                        <div className="view-info-container">
                            <div className="view-title">
                                Detailed Project Analytics
                            </div>
                            <div className="view-description">
                                <BreadCrumbs
                                    links={[
                                        {
                                            href: Navigator.paths.dashboard_author_channel_view(this.props.match.params.channelId),
                                            text: currentChannel.name
                                        }

                                    ]}
                                />
                            </div>
                        </div>
                    </SubNav>

                    <ProjectListAnalyticsView
                        projects={projects}
                        onProjectClick={this.onProjectClick}
                        projectId={this.props.match.params.projectId}
                        channelId={currentChannelId}
                    />
                </div>
            </div>
        );
    }
}

ChannelProjectAnalyticsView.propTypes = propTypes;
ChannelProjectAnalyticsView.defaultProps = defaultProps;

export default withRouter(ChannelProjectAnalyticsView);